<template>
  <div class="system_customers">
    <!-- 面包屑 -->
    <el-form v-model="queryData">
      <el-input style="width: 200px; margin: 0 10px 10px" v-model.trim="queryData.model.mobile" placeholder="手机号"
        clearable @clear="clear"></el-input>
      <el-select v-model="queryData.model.identity" placeholder="请选择身份" style="width: 200px; margin: 0 10px 10px" @change="search">
        <el-option label="客服" value="CUSTOMER_SERVICE" />
        <el-option label="用户" value="USER" />
      </el-select>
      <el-button class="search" type="primary" @click="search">搜索</el-button>
      <!-- <el-button class="search" type="primary" @click="add_click">添加客服</el-button> -->
    </el-form>
    <!-- table -->

    <el-table class="table" :data="tableData" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      v-loading="tabLoading">
      <el-table-column prop="id" label="用户ID" width="100" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="mobile" label="手机号" width="150" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column prop="avatar" label="头像" width="100" :show-overflow-tooltip="true" v-if="queryData.model.identity == 'CUSTOMER_SERVICE'">
        <template slot-scope="scope">
            <el-popover placement="top-start" title="" trigger="hover">
              <img
                :src="scope.row.avatar"
                alt=""
                style="width: 100px; height: 100px"
              >
              <img
                slot="reference"
                :src="scope.row.avatar"
                style="width: 50px; height: 50px"
              >
            </el-popover>
          </template>
      </el-table-column>
      <el-table-column prop="country" label="国家" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="timezone" label="时区" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="identity" label="身份信息" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.identity == 'CUSTOMER_SERVICE'">客服</el-tag>
          <el-tag v-else>用户</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="imAppUserId" label="ImAppUserId" width="100" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="imAppName" label="项目名称" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="imAppId" label="ImAppId" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="imEnableFlag" label="启用状态" width="100" v-if="queryData.model.identity == 'CUSTOMER_SERVICE'">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.imEnableFlag" active-color="#13ce66" inactive-color="#A4B8CF" active-value="1"
            inactive-value="0" @change="changeImEnableFlag($event, scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="autoReplyContentEnableStatus" label="自动回复开关" width="100" v-if="queryData.model.identity == 'CUSTOMER_SERVICE'">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.autoReplyContentEnableStatus" active-color="#13ce66" inactive-color="#A4B8CF" active-value="1"
            inactive-value="0" @change="changeAutoReplyContentEnableStatus($event, scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="imToken" label="ImToken" width="350"> </el-table-column>
      <el-table-column prop="autoReplyContent" label="自动回复内容" width="200" :show-overflow-tooltip="true" v-if="queryData.model.identity == 'CUSTOMER_SERVICE'"> </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button class="edeit" @click="copyClk(scope.row)" type="text" size="small"
            v-clipboard:copy="imAddress + '?imToken=' + scope.row.imToken + '&imAppId=' + scope.row.imAppId + '&imAppUserId=' + scope.row.id + '&timezone=' + scope.row.timezone">复制链接</el-button>
          <el-button class="edeit" @click="smsClk(scope.row)" type="text" size="small" v-if="queryData.model.identity == 'CUSTOMER_SERVICE'">修改信息</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="blank"></div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="queryData.pageNum" :page-sizes="[15, 30, 50, 100, 200, total]" :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="form" label-width="150px">
        <!-- v-if="title == '添加客服信息'" -->
        <el-form-item label="客服手机号:" v-if="title == '添加客服信息'">
          <el-input v-model="form.imAppUserId" style="width: 92%" />
        </el-form-item>
        <el-form-item label="自动回复内容:">
          <el-input v-model="form.autoReplyContent" style="width: 92%" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item label="自动回复开关:">
          <el-select v-model="form.autoReplyContentEnableStatus" placeholder="请选择" style="width: 92%">
            <el-option label="开启" value="1" />
            <el-option label="关闭" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="头像上传:">
          <el-upload
            action="#"
            accept="image/*"
            :show-file-list="false"
            :http-request="uploadAvatar"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="retunDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "@/utils/request";
import uploadHubFile from "@/utils/hubFileUpload";

export default {
  name: "system_customers",
  data() {
    return {
      queryData: {
        pageSize: 15,
        pageNum: 1,
        model: {
          mobile: "",
          identity: "CUSTOMER_SERVICE"

        }
      },
      title: "",
      show: false,
      tabLoading: false,
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        identity: "CUSTOMER_SERVICE",
        imAppId: "",
        autoReplyContent: "",
        autoReplyContentEnableStatus: "",
        avatar: "",
        id: ""
      },
      imAddress: ''
    };
  },
  created() {
    let imAppId = sessionStorage.getItem('imAppId')
    if (imAppId) {
      this.form.imAppId = imAppId
    }
    this.getDataList();
    this.getSystem()
  },
  methods: {
    smsClk(row) {
      console.log(row);
      this.dialogVisible = true;
      this.form.imAppUserId = row.imAppUserId
      this.form.autoReplyContent = row.autoReplyContent
      this.form.autoReplyContentEnableStatus = row.autoReplyContentEnableStatus
      this.form.avatar = row.avatar || ""
      this.form.id = row.id
      this.form.imAppId = row.imAppId
      this.title = '修改客服信息'
    },
    async uploadAvatar({ file }) {
      if (!file.type.startsWith('image/')) {
        return this.$message.error('请选择图片文件')
      }
      if (file.size > 5 * 1024 * 1024) {
        return this.$message.error('图片大小不能超过5MB')
      }
      try {
        this.form.avatar = await uploadHubFile(file)
        this.$message.success('头像上传成功')
      } catch (error) {
        this.$message.error(error.message || '头像上传失败')
      }
    },

    // 获取配置信息
    getSystem() {
      post("/admin/config/getByCondition", { key: 'IM_ADDRESS' }).then((res) => {
        this.imAddress = res.data.data.value
      });
    },
    retunDialogVisible() {
      if (!this.form.imAppUserId.trim()) {
        return this.$message.error('手机号不能为空')
      }
      if (!this.form.autoReplyContent.trim()) {
        return this.$message.error('自动回复内容不能为空')
      }
      if (this.title == '添加客服信息') {
        post("/admin/user/add", this.form).then((res) => {
          if (res.data.code == 20000) {
            this.dialogVisible = false
            this.$message.success(res.data.message)
            this.getDataList('CUSTOMER_SERVICE');
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        post("/admin/user/update", this.form).then((res) => {
          if (res.data.code == 20000) {
            this.dialogVisible = false
            this.$message.success(res.data.message)
            this.getDataList();
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    changeAutoReplyContentEnableStatus(autoReplyContentEnableStatus, row) {
      post("/admin/user/update", {
        id: row.id,
        autoReplyContentEnableStatus,
      }).then((res) => {
        if (res.data.code != 20000) {
          row.autoReplyContentEnableStatus = autoReplyContentEnableStatus === "1" ? "0" : "1";
          this.$message.error(res.data.message);
        } else {
          this.$message.success(res.data.message);
          this.getDataList();
        }
      }).catch(() => {
        row.autoReplyContentEnableStatus = autoReplyContentEnableStatus === "1" ? "0" : "1";
        this.$message.error("操作失败");
      });
    },
    changeImEnableFlag(imEnableFlag, row) {
      post("/admin/user/update", {
        id: row.id,
        imEnableFlag,
      }).then((res) => {
        if (res.data.code != 20000) {
          row.imEnableFlag = imEnableFlag === "1" ? "0" : "1";
          this.$message.error(res.data.message);
        } else {
          this.$message.success(res.data.message);
          this.getDataList();
        }
      }).catch(() => {
        row.imEnableFlag = imEnableFlag === "1" ? "0" : "1";
        this.$message.error("操作失败");
      });
    },
    copyClk() {
      this.$message.success('复制成功')
    },
    add_click() {
      this.form = {
        imAppUserId: "",
        identity: "CUSTOMER_SERVICE",
        imAppId: sessionStorage.getItem('imAppId') || "",
        autoReplyContent: "",
        autoReplyContentEnableStatus: "",
        avatar: "",
        id: ""
      }
      this.dialogVisible = true
      this.title = '添加客服信息'
    },

    clear() {
      this.getDataList();

    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.total = 0;
      this.queryData.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.getDataList();
    },

    search() {
      this.queryData.pageNum = 1;
      this.total = 0;
      this.tableData = [];
      this.getDataList();
    },
    getDataList(identity) {
      this.tabLoading = true;

      try {
        this.loading = true;
        if (identity) {
          this.queryData.model.identity = identity;
        }
        post("/admin/user/findUserPage", this.queryData).then((res) => {
          this.tabLoading = false;
          this.loading = false;
          const list = res.data.data.data || [];
          this.tableData = list.map((item) => ({
            ...item,
            imEnableFlag:
              item.imEnableFlag != null ? String(item.imEnableFlag) : "0",
          }));
          this.total = res.data.data.total;
        });
      } catch (error) {
        this.tabLoading = false;

        this.loading = false;
      }
    },
  },
};
</script>

<style>
.system_customers .el-col {
  margin-left: 10px;
}

.el-tag {
  background-color: #f7fcfb;
  border-color: #e9fdf9;
}

.el-table__header .el-table-column--selection .cell .el-checkbox:after {
  content: '全选';
  margin-left: 5px;
}
</style>
<style lang="scss" scoped>
.el-icon-arrow-left {
  position: none;
}

.succ {
  color: #67c23a;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
}
</style>
